import { mapStore } from 'src/features/Map/state/mapStore'
import { WildCardTitleSearchConnection } from 'src/types/schema/graphql'
import { parseLocations } from '../../forYou/functions/parseLocations'
import { parseMapboxPlaces } from '../../forYou/functions/parseMapboxPlaces'
import { searchLocationsByWildcard } from '../../forYou/functions/searchLocationsByWildcard'
import { ICombinedData } from '../../forYou/types/ICombinedData'

const accessToken = process.env.NEXT_PUBLIC_MAPBOX_TOKEN
const setDefaultCombinedRouteInputData = mapStore.getState().setDefaultCombinedRouteInputData

export const loadOptions = (inputValue: string, callback: (options: ICombinedData[]) => void) => {
    let locations: ICombinedData[] = []
    let places: ICombinedData[] = []
    ;(async () =>
        await Promise.all([
            await searchLocationsByWildcard(inputValue).then(
                (res: WildCardTitleSearchConnection) => {
                    const parsedLocs: ICombinedData[] = parseLocations(res.items)
                    locations.push(...parsedLocs)
                }
            ),
            await fetch(
                `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
                    inputValue
                )}.json?access_token=${accessToken}&limit=25&autocomplete=true&country=US`
            )
                .then((response) => response.text())
                .then((res) => JSON.parse(res))
                .then((json) => {
                    const filteredPlaces = json.features.filter(
                        (item) => item.place_type[0] !== 'postcode'
                    )
                    const parsedPlaces: ICombinedData[] = parseMapboxPlaces(filteredPlaces)
                    places.push(...parsedPlaces)
                })
                .catch((err) => console.error({ err })),
        ]).then(() => {
            const combinedData: ICombinedData[] = [...locations, ...places]
            setDefaultCombinedRouteInputData(combinedData)
            callback(combinedData)
        }))()
}
